/** Shared styles for CMS HTML: spacing, touch targets, footer/IP lines (API content). */
export const HELP_HTML_PROSE = [
  'help-about-html prose prose-sm sm:prose-base max-w-none w-full mx-0 text-left text-slate-800',
  '[&_*]:!text-left',
  '[&_p]:!text-left [&_div]:!text-left [&_span]:!text-left [&_h1]:!text-left [&_h2]:!text-left [&_h3]:!text-left',
  '[&_li]:!text-left [&_ul]:!text-left [&_ol]:!text-left',
  '[&_button]:!text-center',
  '[&_p]:mb-4 [&_p]:leading-relaxed [&_p]:text-slate-700',
  '[&_strong]:font-semibold [&_strong]:text-slate-900',
  '[&_a]:font-medium [&_a]:text-blue-600 [&_a:hover]:text-blue-700 [&_a]:underline underline-offset-2',
  '[&_p+button]:mt-8 [&_p+button]:block',
  '[&_a+button]:mt-8 [&_a+button]:block',
  '[&_div+button]:mt-8',
  '[&_br+button]:mt-8',
  '[&_button]:inline-flex [&_button]:items-center [&_button]:justify-center',
  '[&_button]:min-h-[44px] [&_button]:touch-manipulation [&_button]:rounded-xl [&_button]:border-0',
  '[&_button]:bg-blue-600 [&_button]:px-5 [&_button]:py-2.5 sm:[&_button]:px-6 [&_button]:font-semibold [&_button]:text-white',
  '[&_button]:shadow-sm [&_button]:transition-colors [&_button]:active:bg-blue-800 [&_button]:hover:bg-blue-700',
  '[&_button]:w-full sm:[&_button]:w-auto sm:[&_button]:min-w-[min(100%,280px)]',
  '[&_button+button]:mt-3',
  '[&_em]:text-sm [&_em]:leading-relaxed [&_em]:text-slate-600 [&_em]:italic',
  '[&_i]:text-sm [&_i]:leading-relaxed [&_i]:text-slate-600 [&_i]:italic',
  '[&_p:last-child]:text-sm [&_p:last-child]:text-slate-500 [&_p:last-child]:font-normal [&_p:last-child]:not-italic',
].join(' ')
